module.exports = __webpack_public_path__ + "public/Icons/store.svg?c21c92b1";